import RfqDetail from './RfqDetailContainer';

export default RfqDetail;
